// extracted by mini-css-extract-plugin
export default {"button":"alphabtize-btn_button__hsMd4"};